import { Alert } from "reactstrap";
import { useState } from "react";

const InfoAlert = ({
  question,
  answer,
  isOpen = true,
  onClose,
  className = "",
}) => {
  const [isVisible, setIsVisible] = useState(isOpen);

  const handleClose = () => {
    setIsVisible(false);
    if (onClose) {
      onClose();
    }
  };

  if (!isVisible) {
    return null;
  }

  return (
    <Alert
      className={`bg-[#E6ECFD] border-2 border-[#0136BD] rounded-lg p-4 relative ${className}`}
      style={{ borderColor: "#0136BD" }}
    >
      <button
        type="button"
        className="absolute top-4 right-4 text-[#0136BD] hover:text-[#0128A0] focus:outline-none"
        onClick={handleClose}
        aria-label="Fermer"
      >
        <i className="fas fa-times text-[14px]" />
      </button>

      <div className="flex items-start gap-4 pr-8">
        <div className="flex-shrink-0">
          <div className="w-7 h-7 rounded-full border-[3px] border-[#0136BD] flex items-center justify-center">
            <span className="text-md text-[#0136BD] font-bold">i</span>
          </div>
        </div>

        <div className="flex-1">
          <h3 className="font-extrabold text-[14px] mb-1 text-[#0136BD]">
            {question}
          </h3>
          <span className="text-[#0136BD] text-[14px]">{answer}</span>
        </div>
      </div>
    </Alert>
  );
};

export default InfoAlert;
